/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SsoimageCategoriesQueryResponse,
  GetApiV1SsoimageCategories401,
  GetApiV1SsoimageCategories500,
} from "../../types/SSOImageController/GetApiV1SsoimageCategories.ts";

function getGetApiV1SsoimageCategoriesUrl() {
  const res = { method: "GET", url: `/api/v1/ssoimage/categories` as const };
  return res;
}

/**
 * @description Retorna todos os valores do enum ESSOCategory com id e nome. **(Requer Authorization para autenticação)**
 * @summary Buscar categorias SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage/categories}
 */
export async function getApiV1SsoimageCategories(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SsoimageCategoriesQueryResponse,
    ResponseErrorConfig<
      GetApiV1SsoimageCategories401 | GetApiV1SsoimageCategories500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SsoimageCategoriesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
